/* eslint-disable react/destructuring-assignment */
import {
  Button,
  Divider,
  List,
  ListItem,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { uniqueId } from 'lodash';
import React, { useEffect } from 'react';

import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import { useBoolean } from '@/utils/hooks';
import { useDispatch } from 'react-redux';
import { setTotalFare, setDepartFare } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { useAppSelector } from '@/utils/hook';
// import { mappingSelectedPassengerObject } from '@/utils/passengerMapping';
// import { getTotalTripPrice } from '@/utils/tripMapping';

const StyledList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: theme.palette.medium,
  margin: 0,
  position: 'relative',
  border: `1px solid ${style.color.white1}`,
  borderRadius: '3px',
  ':before': {
    content: '" "',
    position: 'absolute',
    top: '10px',
    width: '44px',
    height: '5px',
    left: '50%',
    backgroundColor: theme.palette.black7,
    borderRadius: theme.palette.borderRadius?.input,
    transform: 'translateX(-50%)',
  },
}));
const StyledListItem = styled(ListItem)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
});
const BoldedTypography = styled(Typography)({
  fontWeight: 'bold',
});

const StyledDivider = styled(Divider)({
  marginTop: '16px',
  marginBottom: '16px',
  borderBottomStyle: 'dashed',
});

export interface IPriceDetails {
  adult?: number;
  child?: number;
  infant?: number;
  adtFare: number;
  taxFee: number;
  chdFare: number;
  infFare: number;
  airline?: string;
  airlineReturn?: string;
  isDesktop?: boolean;
  baggagePrice?: number;
  baggagePriceDepart: number;
  baggagePriceReturn: number;
  taxAdt: number;
  taxChild: number;
  taxInfant: number;
  isPayment?: boolean;
  flightPriceDiff?: number;
  discountAmount?: number;
  onClose?: () => void;
  onNext?: () => any;
  isDepart?: boolean;
  isNotMarkedUp?: boolean;
  isRoundTrip?: boolean;
  isFailPayment?: boolean;
  isSuccessPayment?: boolean;
  priceReturn: any;
  sx?: React.CSSProperties
}
export const PriceDetailComponent: React.FC<IPriceDetails & { isSummary: boolean, type: 'return' | 'depart' }> = ({
  type, isRoundTrip, adtFare, infFare, chdFare, taxAdt, taxChild, taxInfant, airline, adult, child, infant, isSummary, baggagePriceDepart = 0, baggagePriceReturn = 0,
}) => {
  const totalPriceAdt = taxAdt + adtFare;
  const totalPriceChd = taxChild + chdFare;
  const totalPriceInf = taxInfant + infFare;
  const totalPassenger = (adult || 1) + (child || 0) + (infant || 0);
  const baggagePrice = type === 'return' ? baggagePriceReturn : baggagePriceDepart;
  const totalPrice = totalPriceAdt + totalPriceInf + totalPriceChd + baggagePrice;

  if (isSummary) {
    return (

      <Stack
        direction="row"
        justifyContent="space-between"
      >
        <Typography
          variant="body2"
          sx={{
            color: style.color.black1,
          }}
        >
          {!isRoundTrip ? `${airline} (${totalPassenger} khách)` : type === 'depart' ? `Chiều đi (${totalPassenger} khách)` : `Chiều về (${totalPassenger} khách)`}

        </Typography>
        <Typography
          variant="body2"
          color={style.color.black1}
        >
          {convertMoney(totalPrice)}
        </Typography>

      </Stack>
    );
  }
  return (
    <Stack spacing="10px">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: '16px',
            height: '22px',
            fontWeight: 500,
            color: style.color.blue3,
          }}
        >
          {!isRoundTrip ? 'TỔNG TIỀN' : type === 'depart' ? 'CHIỀU ĐI' : 'CHIỀU VỀ'}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          color={style.color.black1}
        >
          {convertMoney(totalPrice)}
        </Typography>

      </Stack>
      <Stack spacing="4px">
        <Stack
          direction="row"
          justifyContent="space-between"
        >
          <Typography
            variant="body2"
            sx={{
              color: style.color.black1,
            }}
          >
            {`${airline} (Người lớn) x${adult}`}
          </Typography>
          <Typography
            variant="body2"
            color={style.color.black1}
          >
            {convertMoney(totalPriceAdt)}
          </Typography>

        </Stack>
        {totalPriceChd !== 0 && (

          <Stack
            direction="row"
            justifyContent="space-between"
          >
            <Typography
              variant="body2"
              sx={{
                color: style.color.black1,
              }}
            >
              {`${airline} (Trẻ em) x${child}`}
            </Typography>
            <Typography
              variant="body2"
              color={style.color.black1}
            >
              {convertMoney(totalPriceChd)}
            </Typography>

          </Stack>
        )}
        {totalPriceInf !== 0 && (

          <Stack
            direction="row"
            justifyContent="space-between"
          >
            <Typography
              variant="body2"
              sx={{
                color: style.color.black1,
              }}
            >
              {`${airline} (Em bé) x${infant}`}
            </Typography>
            <Typography
              variant="body2"
              color={style.color.black1}
            >
              {convertMoney(totalPriceInf)}
            </Typography>

          </Stack>
        )}
        {baggagePrice !== 0 && (

          <Stack
            direction="row"
            justifyContent="space-between"
          >
            <Typography
              variant="body2"
              sx={{
                color: style.color.black1,
              }}
            >
              Hành lý mua thêm
            </Typography>
            <Typography
              variant="body2"
              color={style.color.black1}
            >
              {convertMoney(baggagePrice)}
            </Typography>

          </Stack>
        )}
      </Stack>
    </Stack>

  );
};

export const PriceDiscountComponent = ({
  discountAmount, isSummary,
}: { discountAmount: number, isSummary?: boolean }) => {
  if (isSummary) {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
      >
        <Typography
          variant="body2"
          sx={{
            color: style.color.black1,
          }}
        >
          Giảm giá
        </Typography>
        <Typography
          variant="body2"
          color={style.color.black1}
        >
          -
          {' '}
          {convertMoney(discountAmount || 0)}
        </Typography>

      </Stack>

    );
  }
  return (
    <Stack spacing="10px">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 700,
            color: style.color.blue3,
          }}
        >
          GIẢM GIÁ
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          color={style.color.black1}
        >
          -
          {' '}
          {convertMoney(discountAmount || 0)}
        </Typography>

      </Stack>
      <Stack spacing="4px">
        <Stack
          direction="row"
          justifyContent="space-between"
        >
          <Typography
            variant="body2"
            sx={{
              color: style.color.black1,
            }}
          >
            Giảm giá trực tiếp
          </Typography>
          <Typography
            variant="body2"
            color={style.color.black1}
          >
            -
            {' '}
            {convertMoney(discountAmount || 0)}
          </Typography>

        </Stack>

      </Stack>
    </Stack>

  );
};

const calculateTotalPrice = ({
  type, isRoundTrip, adtFare, infFare, chdFare, taxAdt, taxChild, taxInfant, airline, adult, child, infant, isSummary, baggagePriceDepart = 0, baggagePriceReturn = 0, isFailPayment, discountAmount,
}: IPriceDetails & { type: 'depart' | 'return', isSummary?: boolean }) => {
  const totalAmount = isFailPayment ? (discountAmount || 0) : ((adult || 0) + (child || 0)) * (discountAmount || 0);

  const totalPriceAdt = taxAdt + adtFare;
  const totalPriceChd = taxChild + chdFare;
  const totalPriceInf = taxInfant + infFare;
  const baggagePrice = type === 'return' ? baggagePriceReturn : baggagePriceDepart;
  const totalPrice = totalPriceAdt + totalPriceInf + totalPriceChd + baggagePrice;
  return {
    totalFare: totalPrice - totalAmount,
    totalAmount,
  };
};

const PriceDetailsNotification: React.FC<IPriceDetails> = (props) => {
  const {
    adult,
    adtFare,
    child,
    chdFare,
    infant,
    onClose,
    onNext,
    taxFee,
    isDesktop,
    infFare,
    baggagePrice,
    isPayment,
    // flightPriceDiff,
    discountAmount,
    isDepart,
    isRoundTrip,
    airline,
    airlineReturn,
    priceReturn,
  } = props;
  const dispatch = useDispatch();

  const {
    totalFare: cachedTotalFare, priceIsSet, flight, returnFlight,
  } = useAppSelector((state) => state.selectedFlight);
  const [isViewMore, setIsViewMore] = useBoolean(!isPayment);

  const { totalAmount, totalFare: totalFareDapart } = calculateTotalPrice({
    ...props,
    type: 'depart',
  }) || 0;

  const priceObjReturn = priceReturn ? calculateTotalPrice({
    ...props,
    ...priceReturn,
    discountAmount: priceReturn.discountAmt,
    type: 'return',
  }) : {} as any;

  const totalDiscountAmount = totalAmount + (+priceObjReturn.totalAmount || 0);

  const totalFare = totalFareDapart + (+priceObjReturn.totalFare || 0);

  const isFull = (!isDesktop || (isViewMore && isDesktop));

  const departAirline = airline || flight?.company.name;
  const returnAirline = airlineReturn || returnFlight?.company.name;

  useEffect(() => {
    if (totalFare && cachedTotalFare !== totalFare && !priceIsSet) {
      dispatch(setTotalFare(totalFare));
    }

    if (isDepart) { dispatch(setDepartFare(totalFare)); }
  }, []);

  return (
    <Stack
      sx={{
        padding: '16px',
        borderRadius: '3px',
      }}
      spacing="16px"
    >
      <StyledListItem key={uniqueId()}>
        <Typography variant={isDesktop ? 'title' : 'heading'}>
          Tổng thanh toán
        </Typography>
        {isDesktop && (
          <Button onClick={setIsViewMore.toggle}>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                textDecoration: 'underline',
              }}
              color={style.color.product3}
              variant="captionMedium"
            >
              {isViewMore ? 'Thu gọn' : 'Chi tiết'}
            </Typography>
          </Button>
        )}
      </StyledListItem>
      <PriceDetailComponent
        type="depart"
        isSummary={!isFull}
        {...props}
        airline={departAirline}
      />
      {priceReturn && isRoundTrip && (
        <>
          {isFull && (
          <Divider sx={{
            border: '1px dashed #D5DADD;',
            borderBottomWidth: '0',
          }}
          />

          )}
          <PriceDetailComponent
            type="return"
            isRoundTrip={isRoundTrip}
            isSummary={!isFull}
            {...props}
            {...priceReturn}
            airline={returnAirline}
          />
        </>
      )}
      {totalDiscountAmount !== 0 && (
      <>
        <Divider sx={{
          border: '1px dashed #D5DADD;',
          borderBottomWidth: '0',
        }}
        />
        <PriceDiscountComponent
          isSummary={!isFull}
          discountAmount={totalDiscountAmount}
        />
      </>

      )}
      <Divider />
      <StyledListItem key={uniqueId()}>
        <BoldedTypography variant={isDesktop ? 'contentBold' : 'title'}>
          Giá cuối cùng
        </BoldedTypography>
        <Typography variant={isDesktop ? 'contentBold' : 'title'}>
          {convertMoney(totalFare)}
        </Typography>
      </StyledListItem>
      {!isDesktop && (
      <Button
        fullWidth
        sx={{
          width: '100%',
          height: '44px',
          color: 'white',
          backgroundColor: (theme) => theme.palette.product3,
          ':hover span': {
            color: 'white',
          },
        }}
        variant="contained"
        onClick={onClose}
      >
        <Typography
          color="white"
          variant="contentBold"
        >
          Đóng
        </Typography>
      </Button>

      )}
    </Stack>
  );
};

export default PriceDetailsNotification;
